import { render, staticRenderFns } from "./VtsCenterPracticeUpsertForm.vue?vue&type=template&id=e9c06408"
import script from "./VtsCenterPracticeUpsertForm.vue?vue&type=script&lang=ts"
export * from "./VtsCenterPracticeUpsertForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports